import type { PermissionSelector } from "@/hooks/usePermission";

export const canManageAllDocuments: PermissionSelector = (x) => x.documents.canManageAll;
